<template>
  <div class="news-container">
    <div class="left-menu">
      <slot name="leftMenu"></slot>
    </div>
    <div class="content">
      <slot name="newsContent"> </slot>
    </div>
    <div class="right-menu">
      <slot name="rightMenu"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",
  props: {
    config: Object,
  },
  data() {
    return {
      mode: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.news-container {
  display: flex;
}
.content {
  flex-shrink: 1;
  flex-grow: 1;
  overflow: hidden;
}
.left-menu,
.right-menu {
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
